
/* ---------------------- 🔹 Fetch metadata ---------------------- */
function parseUrlSafe(rawUrl) {
    try {
        const parsed = new URL(String(rawUrl || ""));
        const host = parsed.hostname.replace(/^www\./i, "");
        const pathPart = parsed.pathname
            .split("/")
            .filter(Boolean)
            .pop() || "";
        const cleanedPath = decodeURIComponent(pathPart)
            .replace(/[-_]+/g, " ")
            .replace(/\.[a-z0-9]{1,6}$/i, "")
            .trim();
        const title = cleanedPath || host || String(rawUrl || "");
        return { ok: true, href: parsed.href, host, title };
    } catch {
        return {
            ok: false,
            href: String(rawUrl || ""),
            host: "",
            title: String(rawUrl || "") || "Unknown source",
        };
    }
}

function faviconForHost(host) {
    if (!host) return "";
    return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=64`;
}

// Free + robust metadata fallback:
// - No paid/rate-limited metadata API call.
// - Derive human-readable fields from URL itself.
// - Always returns a usable card so the Sources panel never gets stuck.
export async function fetchMeta(url) {
    const info = parseUrlSafe(url);
    return {
        url: info.href,
        title: info.title,
        description: info.host ? `แหล่งอ้างอิงจาก ${info.host}` : "แหล่งอ้างอิง",
        image: faviconForHost(info.host),
        site: info.host || "unknown",
    };
}
